import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
// import { DotKhaoSatService } from 'tnx-khaosat-service';
import { ColumnSchemaBase, ComponentContextService, DataListBase, GridInfo, ModelSchema } from 'tnx-shared';

@Component({
    selector: 'app-khao-sat-client',
    templateUrl: './khao-sat-client.component.html',
    styleUrls: ['./khao-sat-client.component.scss'],
    providers: [ComponentContextService]
})
export class KhaoSatClientComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};

    constructor(
        protected _injector: Injector,
        // protected _dotKhaoSatService: DotKhaoSatService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.objectName = 'đợt khảo sát';
        // this.setting.baseService = this._dotKhaoSatService;
        this.modelSchema = [
            new ModelSchema({ field: 'sort', name: 'Sắp xếp', fullName: 'Sắp xếp', description: '' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: '' }),
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên', description: '' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'code',
                label: this._translateService.instant('Mã'),
                fullTextSearch: true,
                width: '28em'
            }),
            new ColumnSchemaBase({
                field: 'name',
                label: this._translateService.instant('Tên'),
                fullTextSearch: true,
                width: '28em'
            }),
            new ColumnSchemaBase({
                field: 'description',
                label: this._translateService.instant('Mô tả')
            }),
            new ColumnSchemaBase({
                field: 'sort',
                width: '10em',
                label: this._translateService.instant('Thứ tự')
            }),
        ];
        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo: GridInfo) {
        gridInfo.sorts.splice(0, 0,
            { field: 'sort', dir: 1 }
        );
    }
}
